module.exports = __webpack_public_path__ + "static/media/royalimpressionlogo.e77bb425.png";